import React, { useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { useAppContext } from 'hooks';
import {
  isAuth,
  getSubscribePeriod,
  getUserId,
  getRenew,
  getSubscribeDate,
  getSubscribePrice,
} from 'containers/authorization/selectors';
import Close from 'assets/svg/Close';

import { useCheck } from './hooks';
import { Container, Text, Highlight, Button } from './styles';

const SubscribeMessage = () => {
  const ref = useRef();
  const refOffset = useRef();
  const { t } = useTranslation(['app', 'errors']);
  const { pathname } = useLocation();
  const auth = useSelector(isAuth);
  const userId = useSelector(getUserId);
  const subscribePeriod = useSelector(getSubscribePeriod) || 0;
  const renew = useSelector(getRenew);
  const subscribeDate = useSelector(getSubscribeDate);
  const subscribePrice = useSelector(getSubscribePrice);
  const isBasicUser = useMemo(
    () => !renew && Boolean(userId) && (!subscribeDate || new Date(subscribeDate).valueOf() < Date.now()),
    [renew, subscribeDate, userId]
  );

  const isIntro = useMemo(() => pathname === '/intro', [pathname]);
  const pathnameToPremium = useMemo(() => (auth ? '/account/abo' : '/registrieren'), [auth]);
  const [errorApp] = useAppContext();
  const [isShow, onClose] = useCheck(isIntro, Boolean(userId), subscribePeriod, isBasicUser, subscribePrice);

  const content = useMemo(() => {
    if (errorApp) {
      return (
        <Container ref={ref} $isOpen>
          <Text>
            {t(`errors:${errorApp}`)} <Highlight to="/support">{`${t('Report a problem')}.`}</Highlight>
          </Text>
        </Container>
      );
    }
    return (
      <Container ref={ref} $isOpen={isShow}>
        {!isIntro && (
          <>
            <Text>
              {t(isBasicUser ? 'Now get yourself' : 'Switch to an')}{' '}
              <Highlight to={pathnameToPremium}>{isBasicUser ? 'Fintool Premium' : t('annual subscription')}</Highlight>{' '}
              {t(isBasicUser ? 'and get access to our academy' : 'now and save money')}
            </Text>
            <Button type="button" onClick={onClose} title="Close" aria-label="Close">
              <Close />
            </Button>
          </>
        )}
      </Container>
    );
  }, [errorApp, isShow, isIntro, t, isBasicUser, pathnameToPremium, onClose]);

  return (
    <>
      <div ref={refOffset} />
      {content}
    </>
  );
};

export default SubscribeMessage;
